import "@/App.css";
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { Navigation } from "./components/Navigation";
import { Hero } from "./components/Hero";
import { Services } from "./components/Services";
import { Featured } from "./components/Featured";
import { Portfolio } from "./components/Portfolio";
import { Process } from "./components/Process";
import { About } from "./components/About";
import { StickerShop } from "./components/StickerShop";
import { MiniCTA } from "./components/MiniCTA";
import { Contact } from "./components/Contact";
import { Footer } from "./components/Footer";
import { Impressum } from "./components/Impressum";
import { Datenschutz } from "./components/Datenschutz";
import { Widerrufsrecht } from "./components/Widerrufsrecht";
import { Zahlungsmethoden } from "./components/Zahlungsmethoden";
import { CookieBanner } from "./components/CookieBanner";
import { Toaster } from "./components/ui/sonner";
import featureFlags from "./config/featureFlags";

// Home page with all sections
const HomePage = () => (
  <>
    <Navigation />
    <main>
      <Hero />
      <Services />
      <Featured />
      <Portfolio />
      <Process />
      {/* Shop is conditionally rendered based on feature flag */}
      {featureFlags.SHOP_ENABLED && <StickerShop />}
      <MiniCTA />
      <About />
      <Contact />
    </main>
    <Footer />
  </>
);

function App() {
  return (
    <Router>
      <div className="App min-h-screen bg-slate-50">
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/impressum" element={<Impressum />} />
          <Route path="/datenschutz" element={<Datenschutz />} />
          <Route path="/widerrufsrecht" element={<Widerrufsrecht />} />
          <Route path="/zahlungsmethoden" element={<Zahlungsmethoden />} />
        </Routes>
        <CookieBanner />
        <Toaster />
      </div>
    </Router>
  );
}

export default App;
